// A markdown document is text, so a file is decoded here and nowhere else: nothing is uploaded, and what the editor
// takes is exactly what the file holds.

// The document reaches both the preview and the share link on every keystroke, so a file worth opening is one worth
// parsing, sanitising and base64-ing a hundred times over — a megabyte of prose already being a long book.
export const MAX_BYTES = 1024 * 1024;

// The picker's filter, which a drop is under no obligation to respect: what decides there is whether it reads as text.
export const ACCEPT = ".md,.markdown,.mdown,.mkd,.mdx,.txt,text/markdown,text/plain";

export async function readDocument(file: File): Promise<string> {
  if (file.size > MAX_BYTES) throw new Error(`That file is larger than the ${MAX_BYTES / 1024 / 1024} MB this opens.`);

  let text: string;
  try {
    // Fatal, so a picture dropped on the editor is refused rather than pasted in as several thousand replacement
    // characters, which is what a lenient decode makes of one.
    text = new TextDecoder("utf-8", { fatal: true }).decode(await file.arrayBuffer());
  } catch {
    throw new Error("That file is not UTF-8 text, so there is no markdown in it to read.");
  }

  return text.charCodeAt(0) === 0xfeff ? text.slice(1) : text;
}

export function message(error: unknown): string {
  return error instanceof Error ? error.message : String(error);
}
